import { Bed, Bath, Maximize, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { AREAS } from "../data";
import { Reveal } from "./Reveal";

export const FeaturedAreas = () => (
  <section id="featured" data-testid="featured-section" className="py-24 md:py-32 bg-white">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal>
        <p className="eyebrow text-gold mb-4">Recently Sold</p>
        <h2 className="font-heading font-light text-4xl sm:text-5xl tracking-tight leading-none max-w-2xl">
          Homes we've sold across Southern California
        </h2>
        <p className="text-[#52525b] font-light text-lg mt-6 max-w-xl">
          From the foothills of Redlands to the desert-modern estates of Palm Springs and the
          wine country of Temecula — results that speak for themselves.
        </p>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-16">
        {AREAS.map((a, i) => (
          <Reveal key={a.name} delay={i * 0.12}>
            <Link
              to={`/${a.slug}`}
              data-testid={`property-card-${a.slug}`}
              className="group block bg-surface border border-black/5 hover:-translate-y-1 hover:shadow-xl transition-all duration-300"
            >
              <div className="relative overflow-hidden aspect-[4/3]">
                <img
                  src={a.image}
                  alt={`${a.name} home`}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <span
                  data-testid={`sold-badge-${a.slug}`}
                  className="absolute top-4 left-4 bg-gold text-white eyebrow text-[11px] px-4 py-2"
                >
                  Sold
                </span>
              </div>
              <div className="p-7">
                <p className="eyebrow text-[#a1a1aa] text-[11px]">{a.name}, {a.state}</p>
                <p className="font-heading text-2xl mt-2">{a.price}</p>
                <p className="text-[#52525b] font-light text-sm mt-3 leading-relaxed">{a.blurb}</p>
                <p className="text-[#a1a1aa] font-light text-xs mt-3 leading-relaxed">Also serving {a.nearby.slice(0, 3).join(", ")} & nearby</p>
                <div className="flex items-center gap-6 mt-6 pt-6 border-t border-black/5 text-[#52525b] text-sm">
                  <span className="flex items-center gap-2"><Bed size={16} className="text-gold" /> {a.beds} Beds</span>
                  <span className="flex items-center gap-2"><Bath size={16} className="text-gold" /> {a.baths} Baths</span>
                  <span className="flex items-center gap-2"><Maximize size={16} className="text-gold" /> {a.sqft}</span>
                </div>
                <span className="inline-flex items-center gap-1.5 text-sm mt-5 text-[#0a0a0a] group-hover:text-gold transition-colors">
                  Explore {a.name} <ArrowUpRight size={15} />
                </span>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
